
import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import RightSign from "./images/rightSign.svg";
import HeartIcon from "./images/heartIcon.svg";
import CarIcon from "./images/carIcon.png";

const PostInspectionDiyAuctionCard = ({
    assuredPriceFlag = false,
    children,
    showCarIcon = true,
    heading = "CARS24 offer",
    carImage = "",
    isSold = false
}) => {
    return (
        <div styleName={`styles.auctionCard ${showCarIcon ? "" : "styles.noMargin"}`}>
            {
                showCarIcon &&
                <div styleName={"styles.carIconWrapper"}>
                    {isSold ?
                        <span styleName={"styles.soldIcon"}>SOLD</span> :
                        <img styleName={"styles.heartIcon"} src={HeartIcon} alt="heart" />}
                    <img styleName={"styles.CarIcon"} src={carImage ? carImage : CarIcon} alt="CarIcon" />
                </div>
            }
            <h3 styleName={`styles.title ${showCarIcon ? "" : "styles.titleWithoutImage"}`}>
                {heading}
            </h3>
            <div styleName={"styles.auctionPrice"}>
                {
                    children &&
                    children
                }
            </div>
            {
                assuredPriceFlag &&
                <div styleName={"styles.priceFlag"}>
                    <img src={RightSign} alt="right Sign"/>
                    Fixed price
                </div>
            }
        </div>
    );
};

PostInspectionDiyAuctionCard.propTypes = {
    assuredPriceFlag: PropTypes.bool,
    children: PropTypes.any,
    showCarIcon: PropTypes.bool,
    heading: PropTypes.string,
    carImage: PropTypes.string,
    isSold: PropTypes.bool
};

export default PostInspectionDiyAuctionCard;
